/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserBudgetReadModel
 */
export interface UserBudgetReadModel {
    /**
     * 
     * @type {boolean}
     * @memberof UserBudgetReadModel
     */
    hasBudget: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserBudgetReadModel
     */
    budgetLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserBudgetReadModel
     */
    currentUsage?: number | null;
}

/**
 * Check if a given object implements the UserBudgetReadModel interface.
 */
export function instanceOfUserBudgetReadModel(value: object): value is UserBudgetReadModel {
    if (!('hasBudget' in value) || value['hasBudget'] === undefined) return false;
    return true;
}

export function UserBudgetReadModelFromJSON(json: any): UserBudgetReadModel {
    return UserBudgetReadModelFromJSONTyped(json, false);
}

export function UserBudgetReadModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserBudgetReadModel {
    if (json == null) {
        return json;
    }
    return {
        
        'hasBudget': json['hasBudget'],
        'budgetLimit': json['budgetLimit'] == null ? undefined : json['budgetLimit'],
        'currentUsage': json['currentUsage'] == null ? undefined : json['currentUsage'],
    };
}

export function UserBudgetReadModelToJSON(json: any): UserBudgetReadModel {
    return UserBudgetReadModelToJSONTyped(json, false);
}

export function UserBudgetReadModelToJSONTyped(value?: UserBudgetReadModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasBudget': value['hasBudget'],
        'budgetLimit': value['budgetLimit'],
        'currentUsage': value['currentUsage'],
    };
}

